import { ReactElement } from "react";

import styles from "./index.module.css";

export default function Preview(props: {
  preview: string;
  opaque?: boolean;
}): ReactElement {
  return (
    <img
      src={props.preview}
      className={styles.thumbnail}
      style={{
        opacity: props.opaque ? 1 : 0.9,
      }}
      alt="preview"
    />
  );
}
